$('.cart-submit').click(function (event) {
  // Check if any item in the shopping cart has the "Membership" tag
  var hasMembership = window.shoppingCartItems.some(item => item.tags.includes("Membership"));

  if (hasMembership) {
    // If there's a membership item, proceed with regular cart submit
    console.log("Membership item found, proceeding with default form submission.");
  } else {
    event.preventDefault();
    event.stopPropagation();

    $('.loading-overlay').show();
    $('.loading-container').show();

    postDraftOrder(); // Call the function to create the draft order
  }
});

var postDraftOrder = function () {
  var line_items = getShoppingCartData(); // Gather shopping cart items
  console.log("line_items", line_items);
  

  var order_discount = getOrderDiscount(); // Gather any applied discounts
  // console.log("order_discount", order_discount); 

  // Prepare the payload
  var payload = {
      draft_order: { line_items, order_discount }
  };

  
  // Send AJAX request to the Suitelet
  $.ajax({
      url: "https://4583265.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=496&deploy=1&compid=4583265&ns-at=AAEJ7tMQQ3rAzjX2jzI0M_Mcf2TCEoLNPkicansXqNU2NbNsNiQ",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "POST",
      data: JSON.stringify(payload),
      success: function (response) {
          console.log("Draft order response:", response);

          // Redirect to the invoice URL if available
          if (response.invoiceUrl) {
              window.location.href = response.invoiceUrl;
          } else {
              console.error("No invoice URL returned");
              alert("Unable to create draft order. Please try again.");
              $('.loading-overlay').hide();
              $('.loading-container').hide();
          }
      },
      error: function (error) {
          console.error("Error creating draft order:", error);
          alert("An error occurred while creating the draft order. Please try again.");
          $('.loading-overlay').hide();
          $('.loading-container').hide();
      }
  });
};



var getShoppingCartData = function () {
  var shoppingCartItems = window.shoppingCartItems; 
  var lineItems = [];

  shoppingCartItems.forEach((product) => {
    // console.log('product', product)
    let variantId = null;
    let isCustom = true;
    const sku = product.variantInCart.sku || "";

    // Set variantId and isCustom based on SKU
      if (/^(DB|SU|SC)/.test(sku)) {
      // SKUs starting with DB, SU, or SC are not custom
        variantId = product.variantInCart.variant_id;
        isCustom = false;
      }
      
      var item = {
          variant_id: variantId, 
          quantity: product.variantInCart.quantity, 
          regularPrice: product.variantInCart.price / 100,
          webPrice: product.webPrice,
          memberPrice: product.memberPrice,
          title: product.title,
          properties: [
            { key: "SKU", value: `${product.variantInCart.sku}` }
          ],
          custom: isCustom,
          price: product.webPrice,
          tags: product.tags,
          taxable: product.variantInCart.taxable,
          requires_shipping: product.variantInCart.requires_shipping
      };

      // Calculate Member Discount
      if (window.isMember && product.memberPrice) {
          const memberDiscount = item.webPrice - item.memberPrice;
          item.applied_discount = {
              description: "Member Discount",
              value: memberDiscount,
              title: "Member Discount"
          };
      }

      lineItems.push(item); // Add main product item


  });



  return lineItems;
};


var getOrderDiscount = function () {
  var orderDiscount = {};
  if (window.hasDiscountApplied) {
    orderDiscount.description = window.appliedDiscountCode;
    orderDiscount.value = window.appliedDiscountAmount;
    orderDiscount.title = window.appliedDiscountCode;
    orderDiscount.amount = window.appliedDiscountAmount;
    orderDiscount.valueType = "FIXED_AMOUNT";
  }

  return orderDiscount;
}

var addGiftCardNotes = function (properties) {
  var notes = [];

  notes.push({
    name: 'from',
    value: properties["from"]
  });

  notes.push({
    name: 'recipient-name',
    value: properties["recipient-name"]
  });

  notes.push({
    name: 'recipient-email',
    value: properties["recipient-email"]
  });

  notes.push({
    name: 'gift-message',
    value: properties["gift-message"]
  });

  return notes;
}

var addMembershipNotes = function (properties) {
  var notes = [];

  notes.push({
    name: 'member-type',
    value: mapMemberType(properties["member-type"])
  });

  notes.push({
    name: 'number-of-students',
    value: properties["number-of-students"]
  });

  notes.push({
    name: 'org-name',
    value: properties["org-name"]
  });

  notes.push({
    name: 'org-address',
    value: properties["org-address"]
  });

  notes.push({
    name: 'org-city',
    value: properties["org-city"]
  });

  notes.push({
    name: 'org-state',
    value: properties["org-state"]
  });

  notes.push({
    name: 'org-zip',
    value: properties["org-zip"]
  });

  notes.push({
    name: 'org-phone',
    value: properties["org-phone"]
  });

  notes.push({
    name: 'school-district',
    value: properties["school-district"]
  });

  notes.push({
    name: 'hear-about-raft',
    value: properties["hear-about-raft"]
  });

  notes.push({
    name: 'renewal-prompt',
    value: properties["renewal-prompt"]
  });

  return notes;
}

var mapMemberType = function (memberType) {
  var id = 0;

  switch (memberType) {
    case 'teacher':
      id = 1;
      break;
    case 'non-profit':
      id = 2;
      break;
    case 'after-school-program-staff':
      id = 3;
      break;
    case 'volunteer':
      id = 4;
      break;
    case 'special-ed':
      id = 5;
      break;
    case 'religious-program':
      id = 6;
      break;
    case 'pta-pto':
      id = 7;
      break;
    case 'other':
      id = 8;
      break;
    case 'scouts':
      id = 9;
      break;
    case 'home-school':
      id = 10;
      break;
    case 'librarian':
      id = 11;
      break;
    case 'curriculum-developer':
      id = 12;
      break;
    case 'summer-program-staff':
      id = 13;
      break;
    case 'program-for-senior-adults':
      id = 14;
      break;
    case 'parent':
      id = 18;
      break;
    default:
      //unknown member type
      id = -1;
  }

  return id;
}

var addSubscriptionNotes = function (properties) {
  var notes = [];

  notes.push({
    name: 'month-1',
    value: properties["month-1"]
  });

  notes.push({
    name: 'month-2',
    value: properties["month-2"]
  });

  notes.push({
    name: 'month-3',
    value: properties["month-3"]
  });

  notes.push({
    name: 'month-4',
    value: properties["month-4"]
  });

  notes.push({
    name: 'month-5',
    value: properties["month-5"]
  });

  return notes;
}

var addWorkshopNotes = function (properties) {
  var notes = [];

  notes.push({
    name: 'date-time',
    value: properties["date-time"]
  });

  return notes;
}

// Hide the loading overlay on page show (e.g., after navigating back)
window.addEventListener("pageshow", function () {
  $('.loading-overlay').hide();
  $('.loading-container').hide();
});